import styled from 'styled-components';
import { StyledPanelContainer } from '../PanelContainer';

const StyledCameraSettingsContainer = styled(StyledPanelContainer)`
	right: 40px;
	bottom: 40px;
	min-width: 400px;
`;

export { StyledCameraSettingsContainer };
